import Activity from '../../schema/Activity';
import { NO_CALENDAR_EVENT_ID } from '../../helpers/TxpConstants';

export default function getCalendarEventId(
    activityItem: Activity,
    calendarEventIds: any[]
): string {
    let calendarEventIdIndex = activityItem.calendarEventIdIndex;

    // When index is -1, it means that this activity does not have a calendar event
    if (calendarEventIdIndex === NO_CALENDAR_EVENT_ID) {
        return null;
    }
    // use the index to find the calendarEvent in the indexs array
    let calendarEvent = calendarEventIds[calendarEventIdIndex];
    return calendarEvent ? calendarEvent.Id : null;
}
